module.exports = "https://img.zhijierongxing.com/saas/img/mine_menu2.1a301df9.png";